import { render, staticRenderFns } from "./qs1-04.vue?vue&type=template&id=2a03b2b1&scoped=true&"
import script from "./qs1-04.vue?vue&type=script&lang=js&"
export * from "./qs1-04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a03b2b1",
  null
  
)

export default component.exports